// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__30cLL","all_tags_container":"Contact_all_tags_container__Vjp9q"};